﻿// Import general mixin for shared functionality.
import defaultApp from './defaultApp.js';

// Import components for this specific app.
import highlightItem from './components/highlightItem.vue';

const highlightApp = {
    ...defaultApp,
    // Overwrite default app functionalities as you please by using the spread operator.
    components: {
        highlightItem
    },
    computed: {
        ...defaultApp.computed,
        isDay() {
            if (!this.facetsSet) return true;
            let dayFacet = this.data.facets.find(facet => facet.alias === this.constants.keys.daypart);
            let selectedOption = dayFacet.options.find(option => option.selected);
            return selectedOption.valueAlias === '1';
        }
    },
};

export default highlightApp;